<div 
  class="view-column-toggle"
  @show
  gaEvent
  gaCategory="View Information Panel"
  gaAction="Clicked Toggle Column"
  [gaLabel]="isIn ? 'Show' : 'Hide'"
  role="button"
  [attr.aria-label]="isIn ? 'Open Info Panel' : 'Close Info Panel'"
  [attr.aria-expanded] = "!isIn"
  tabindex="0"
  [matTooltip]="isIn ? 'Open Info Panel' : 'Close Info Panel'"
  matTooltipPosition="right"
  (click)="handleToggle()"
  (keyup.enter)="handleToggle()"
  *ngIf="columnToggleVisible">
  <app-icon [icon]="isIn ? 'caret-right' : 'caret-left'"></app-icon>
</div>